/**
 * Simple Icons Mapping
 * Maps node types to Simple Icons component names
 * 
 * Reference: https://simpleicons.org/
 * 
 * Note: Simple Icons use PascalCase naming
 * Example: 'github' -> 'siGithub', 'google-calendar' -> 'siGooglecalendar'
 */

/**
 * Maps node types to Simple Icons component names
 */
export const simpleIconsMap: Record<string, string> = {
  // Communication & Collaboration
  'slack': 'siSlack',
  'discord': 'siDiscord',
  
  // Version Control
  'github': 'siGithub',
  'gitlab': 'siGitlab',
  
  // Payment Processing
  'stripe': 'siStripe',
  'paypal': 'siPaypal',
  
  // Productivity
  'notion': 'siNotion',
  'trello': 'siTrello',
  'asana': 'siAsana',
  'airtable': 'siAirtable',
  'linear': 'siLinear',
  
  // Project Management
  'jira': 'siJira',
  
  // CRM & Sales
  'salesforce': 'siSalesforce',
  'hubspot': 'siHubspot',
  
  // Email & Communication
  'gmail': 'siGmail',
  'sendgrid': 'siSendgrid',
  'twilio': 'siTwilio',
  
  // Google Workspace
  'google-calendar': 'siGooglecalendar',
  'google-docs': 'siGoogledocs',
  'google-drive': 'siGoogledrive',
  'google-sheets': 'siGooglesheets',
  
  // Cloud Storage
  'dropbox': 'siDropbox',
  'aws-s3': 'siAmazons3',

  // Microsoft Services
  'azure-blob-storage': 'siMicrosoftazure',
  'microsoft-onedrive': 'siMicrosoftonedrive',
  'microsoft-sharepoint': 'siMicrosoftsharepoint',
  'microsoft-teams': 'siMicrosoftteams',
  'microsoft-outlook': 'siMicrosoftoutlook',
  
  // Databases
  'mongodb': 'siMongodb',
  'postgresql': 'siPostgresql',
  'mysql': 'siMysql',
  'redis': 'siRedis',
  'elasticsearch': 'siElasticsearch',
  'turso': 'siTurso',
  'sql-server': 'siMicrosoftsqlserver',
  'ms-sql': 'siMicrosoftsqlserver',
  'MsSQL': 'siMicrosoftsqlserver',

  // AI Services
  'openai': 'siOpenai',
  'anthropic': 'siAnthropic',
  'azure-openai': 'siMicrosoftazure',
  
  // Search Engines
  'brave-search': 'siBrave',
};

/**
 * Get Simple Icons component name for a node type
 * @param nodeType - The node type (e.g., 'slack', 'github')
 * @returns Simple Icons component name or undefined
 */
export function getSimpleIconName(nodeType: string): string | undefined {
  return simpleIconsMap[nodeType];
}

/**
 * Check if a node type has a Simple Icons mapping
 * @param nodeType - The node type to check
 * @returns True if mapping exists
 */
export function hasSimpleIcon(nodeType: string): boolean {
  return nodeType in simpleIconsMap;
}
